import { Button, useRecordContext } from 'react-admin'
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import usePhysicalOrders from '../hooks/usePhysicalOrders'
import { ReactElement } from 'react'

type Props = {
  label?: string | ReactElement | boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SnapshotButton = (_: Props) => {
  const record = useRecordContext()
  const { openBatchSnapshot } = usePhysicalOrders()

  const handleClick = () => {
    if (!record) return

    openBatchSnapshot({ batchId: record.id as number })
  }

  return (
    <Button
      startIcon={<CameraAltIcon />}
      label="Snapshot"
      onClick={() => handleClick()}
      data-testid="snapshot-button"
    />
  )
}

export default SnapshotButton
